import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function GalleryModal({ show, onHide }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageURL, setImageURL] = useState("");

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleInsert = () => {
    if (selectedFile) {
      console.log("Uploaded File:", selectedFile);
    }
    if (imageURL) {
      console.log("Image URL:", imageURL);
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>Insert Image</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Select from files */}
        <div className="form-group">
          <label>Select from files</label>
          <div className="file-upload-box">
            <input type="file" onChange={handleFileChange} />
          </div>
        </div>

        {/* Image URL */}
        <div className="form-group mt-3">
          <label>Image URL</label>
          <Form.Control
            type="text"
            placeholder=""
            value={imageURL}
            onChange={(e) => setImageURL(e.target.value)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button className="insert-btn" onClick={handleInsert}>
          Insert Image
        </Button>
      </Modal.Footer>
      <style>
        {
          `
          .custom-modal .modal-content {
  border-radius: 6px;
}

.custom-modal .modal-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.custom-modal .modal-title {
  font-size: 18px;
  font-weight: 500;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 6px;
  display: block;
}

.file-upload-box {
  border: 1px solid #ccc;
  padding: 10px;
  background: #fafafa;
}

.file-upload-box input[type="file"] {
  border: none;
}

.insert-btn {
  background-color: #f28c64 !important;
  border: none !important;
  padding: 8px 16px;
}

.insert-btn:hover {
  background-color: #e57a50 !important;
}`
        }
      </style>
    </Modal>
  );
}